// import Cookies from "js-cookie";
import Cookies from "js-cookie";
import client from "./axios";

const authUrl = window.__env.AUTH_URL;

interface TokenInfo {
  access_token: string;
  expires_in: number;
  refresh_expires_in: number;
  refresh_token: string;
  token_type: string;
  id_token: string;
  "not-before-policy": number;
  session_state: string;
  scope: string;
}

export const Authentication = {
  refreshToken: () => {
    const urlFormEncodedBody = new URLSearchParams();
    const refreshToken = Cookies.get(window.__env.AUTH_REFRESH_TOKEN_NAME);
    urlFormEncodedBody.set("refresh_token", refreshToken || "");
    urlFormEncodedBody.set("client_id", window.__env.AUTH_CLIENT_ID);
    urlFormEncodedBody.set("grant_type", "refresh_token");
    return client.post<TokenInfo>(`${authUrl}/token`, urlFormEncodedBody);
  },
  userInfo: () => client.get(`${authUrl}/userinfo`),
}